import React, { Component } from 'react';
import Slider from 'react-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';
import TestimFamily from '../../images/testimfamily.png';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const dotsSettings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
};
class WhatParentsSay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
        });
    }

    render() {
        return (
            <section className="page-section bg-secondary text-white testimsec">
                <h2 className="yellowtxt">What Parents Say</h2>
                <div
                    id="myCarousel"
                    className="carousel slide"
                    data-ride="carousel"
                >
                    <Slider
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                        {...dotsSettings}
                        className="carousel-indicators"
                    >
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        
                    </Slider>
                    <Slider
                        {...settings}
                        asNavFor={this.state.nav1}
                        ref={slider => (this.slider2 = slider)}
                        className="carousel-inner"
                    >
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “Great experience! So nice for families with a child with special needs! No one was stressed or overstimulated.”                            </p>
                            <p className="overview">Haley J.</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “My grandson had a blast and I was grateful he could be physical on such a blustery winter day.”                            </p>
                            <p className="overview">Jodi G.</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “Had my daughter’s 4th birthday party here. The staff were so incredibly sweet and helpful. I had 25 kids ranging from ages 6 months - 12 years and there was literally something for everyone to play with/on. The place is clean and well kept. I would 100% recommend and I’m planning to have future parties here."                            </p>
                            <p className="overview">
                            Ambrea M.</p>
                        </div>

                         <div className="item carousel-item">
                            <p className="testimonial">
                            “Celebrated my son’s 5th Birthday at We Rock the Spectrum and it was awesome. Perfect for preschool age, private party, and great party room for food & cake. All of the kids had a blast and numerous parents commented on how wonderful the gym was. Highly recommend for birthday parties."                            </p>
                            <p className="overview">
                            Markita S.</p>
                        </div> 
                       
                    </Slider>
                    <img
                        className="quoteimg"
                        src={TestimFamily}
                        alt="Testimonials family"
                    />
                </div>
            </section>
        );
    }
}

export default WhatParentsSay;
